module.exports = __webpack_public_path__ + "static/usage_submit1-ca2f5d1371b672da61a7d8e540022d3c.jpg";